import { RequireAuth, useSignOut } from 'react-auth-kit'
import { useNavigate } from 'react-router-dom'
import BottomNavBar from './Essentials/NavBar'

// import ErrorPage from '../Testing/ErrorPage'

const Home = () => {

  const navigate = useNavigate()
  const signOut = useSignOut()

  const logOut = () => {
    signOut()
    navigate('/login')
  }

  return ( 
    <RequireAuth loginPath='/login' >

      {/* <div className="centeredOnPage" > */}
      
        {/* <SimpleBottomNavigation /> */}
        
        {/* <button onClick={() => navigate('/lookup')}>Contract Lookup For Customer & Item</button> */}
        {/* <button onClick={() => navigate('/mpnlookup')}></button> */}
        {/* <button onClick={() => navigate('/lookupmany')}>Manage Tracings</button> */}
        {/* <button onClick={logOut}>Log Out</button> */}

        <BottomNavBar />

      {/* </div> */}
    </RequireAuth>
  )
  

}

export default Home